export function isBannerOffer(widget) {
    return widget.value.widgetInfo.offers[0]?.url;
}

export function getFirstOfferUrl(widget) {
    return widget.value.widgetInfo.offers[0]?.url;
}

export function getShowcaseUrl(widget) {
    return widget.value.widgetInfo.showcase?.url;
}
